import { defineStore } from "pinia";

import { StateNamespace } from "@/Modules/App/Models/State/StateNamespace";

import GetNotificationsActionHandler from "@/Modules/ActivityCenter/ActionHandlers/GetNotifications";
import UpdateNotificationsActionHandler from "@/Modules/ActivityCenter/ActionHandlers/UpdateNotifications";

import type { ActivityCenterState } from "@/Modules/ActivityCenter/Models/State";
import type { NotificationStatus } from "@/Modules/Models/Domain/ActivityCenter";
import type {
  NotificationsListQuery,
  UpdateNotificationStatusQuery,
} from "@/Modules/Models/Api/ActivityCenter";
import GetNumberOfNewNotificationsActionHandler from "@/Modules/ActivityCenter/ActionHandlers/GetNumberOfNewNotifications";

const activityCenter: ActivityCenterState = {
  isLoading: false,
  notificationsSummary: {},
  pagination: {},
  currentUserNumberNotifications: 0,
  patientNumberNotifications: 0,
};

export const useActivityCenterStore = defineStore(StateNamespace.ACTIVITY_CENTER, {
  state: () => ({ ...activityCenter }),
  getters: {},
  actions: {
    async getNotifications(params: NotificationsListQuery, type: NotificationStatus) {
      const getNotificationsActionHandler = new GetNotificationsActionHandler(this);

      await getNotificationsActionHandler.handle(params, type);
    },

    async updateNotificationsStatus(readedNotifications: UpdateNotificationStatusQuery[]) {
      const updateNotificationsStatusActionHandler = new UpdateNotificationsActionHandler(this);

      await updateNotificationsStatusActionHandler.handle(readedNotifications);
    },

    getNumberOfNewNotifications(userUuid?: string, chatId?: string) {
      const getNumberOfNewNotificationsActionHandler = new GetNumberOfNewNotificationsActionHandler();

      return getNumberOfNewNotificationsActionHandler.handle(userUuid, chatId);
    },
  },
});

export type ActivityCenterStore = ReturnType<typeof useActivityCenterStore>;

export default useActivityCenterStore;
